;(function () {
  angular
    .module('contrast.animations')
    .animation('.search-input', function ($animateCss) {
      'ngInject'

      var lastId = 0
      var _cache = {}

      function getId(el) {
        var id = el[0].getAttribute('data-search-input')
        if (!id) {
          id = ++lastId
          el[0].setAttribute('data-search-input', id)
        }
        return id
      }

      function getState(id) {
        var state = _cache[id]
        if (!state) {
          state = {}
          _cache[id] = state
        }
        return state
      }

      function generateRunner(closing, state, animator, element, doneFn) {
        return function () {
          state.animating = true
          state.animator = animator
          state.doneFn = doneFn
          animator.start().finally(function () {
            if (state.doneFn === doneFn && closing) {
              element[0].style.position = 'static'
              element[0].style.right = ''
            }
            state.animating = false
            state.animator = undefined
            state.doneFn()
          })
        }
      }

      return {
        addClass: function (element, className, doneFn) {
          if (className == 'open') {
            var state = getState(getId(element))

            var animator = $animateCss(element, {
              from: { width: '160px' },
              to: { width: '320px' }
            })
            element[0].style.position = 'absolute'
            element[0].style.right = '0px'
            if (animator) {
              if (state.animating) {
                state.doneFn = generateRunner(
                  false,
                  state,
                  animator,
                  element,
                  doneFn
                )
                return state.animator.end()
              } else {
                return generateRunner(false, state, animator, element, doneFn)()
              }
            }
          }
          doneFn()
        },
        removeClass: function (element, className, doneFn) {
          if (!className) {
            return
          }
          var classNames = className.split(' ')
          if (classNames.indexOf('open') > -1) {
            var state = getState(getId(element))

            var animator = $animateCss(element, {
              from: { width: '320px' },
              to: { width: '160px' }
            })

            if (animator) {
              if (state.animating) {
                state.doneFn = generateRunner(
                  true,
                  state,
                  animator,
                  element,
                  doneFn
                )
                return state.animator.end()
              } else {
                return generateRunner(true, state, animator, element, doneFn)()
              }
            }
          }
          doneFn()
        }
      }
    })
})()
